export default {
  /*酒店星级*/
  HotelStar: [
    // 五星/豪华、四星/高档、三星/舒适、二星/经济、其他
    // 5、4、3、2、99
    {id: '', name: '无星级' },
    {id: '0', name: '请选择星级' },
    // {id: '2', name: '三星以下' },
    // {id: '3', name: '挂牌三星' },
    // {id: '33', name: '三星/快捷连锁' },
    // {id: '4', name: '挂牌四星' },
    // {id: '44', name: '四星标准' },
    // {id: '5', name: '挂牌五星' },
    // {id: '55', name: '五星标准' }
    {id: '2', name: '二星/经济' },
    {id: '3', name: '三星/舒适' },
    {id: '4', name: '四星/高档' },
    {id: '5', name: '五星/豪华' },
    {id: '99', name: '其他' },
  ],
    /*政府酒店星级*/
  governmentHotelStar:[ 
    {id: '2', name: '二星级' },
    {id: '3', name: '三星级' },
    {id: '4', name: '四星级' },
    {id: '5', name: '五星级' },
    {id: '6', name: '白金五星' },
  ],
  /*会议需求*/
  meetRoomObj: [
    {name:'LED',meets:false,id:'1'},
    {name:'投影仪',meets:false,id:'2'},
    {name:'音响',meets:false,id:'3'},
    {name:'舞台',meets:false,id:'4'},
    {name:'搭建',meets:false,id:'5'},
    {name:'序厅',meets:false,id:'6'},
    {name:'茶歇',meets:false,id:'7'},
    {name:'分会场',meets:false,id:'8'},
  ],
  /*酒店、民宿房间类型*/
  roomStyle: [
    { name: '大床房', id:'1',},
    { name: '双床房', id:'2'},
    { name: '三床房', id:'3',},
    { name: '亲子房', id:'4',},
    { name: '套房',id:'5',},
  ],
  /*房间窗户类型*/
  windowStyle: [
    { name: '有窗', id:1,},
    { name: '无窗', id:2},
    { name: '落地窗',id:3,},
    { name: '过道窗',id:4,},
    { name: '室内窗户',id:5,},
    { name: '小窗户',id:6,},
  ],  
  /*床型规格*/
  specsStyle: ['1.8米*1张','1.2米*2张','1.8米*1张+1.3米*1张'],
  /*酒店房间类型*/
  brandroomStyle: [
    { name: '单床房', id:1},
    { name: '双床房', id:2},
    { name: '三床房', id:3},
    { name: '多床房', id:4},
  ],
  /*酒店、民宿的早餐类型*/
  breakfastTypeArr: [
    { id: '1', name: '自助早'},
    { id: '2', name: '自助单早'},
    { id: '3', name: '自助双早'},
    { id: '4', name: '桌早'},
    { id: '5', name: '打包早'},
    { id: '6', name: '无早'},
  ],
  /*酒店资料早餐*/
  breakfastHotel: [
    { id: '1', name: '自助早' },
    { id: '2', name: '桌早' },
    { id: '3', name: '打包早' },
    { id: '4', name: '无早' },
  ],
  /*酒店、自助早类型*/
  buffetBreakfast: [
    { id: '1', name: '自助单早' },
    { id: '2', name: '自助双早' },
  ],
  /**导游等级 */
  guideLevel: [
    { id: '0', name: '未认证' },
    { id: '1', name: '初级导游' },
    { id: '2', name: '中级导游' },
    { id: '3', name: '高级导游' },
    { id: '4', name: '特级导游' },
  ],
  /*会议室时间节点*/
  TimeSlots: [
    { id: 1, name: '上午' },
    { id: 2, name: '下午' },
    { id: 3, name: '晚上' },
    { id: 4, name: '全天(不含晚上)' },
    { id: 5, name: '全天(含晚上)' }
  ],
  /*会议室布局类型*/
  LayoutTypes: [
    { id: 1, name: '剧院式' },
    { id: 2, name: '课桌式' },
    { id: 3, name: '鱼骨型' },
    { id: 4, name: 'U字形' },
    { id: 5, name: '回字型' },
    { id: 6, name: '宴会式' },
    { id: 7, name: '岛屿式' }
  ],
  /*司陪政策备选数组*/
  escortPolicyArr:[
    '8间免1间','10间免1间','16间免1间','20间免1间','无免房政策'
  ],
  minTeamNumArr:[
    { id: '1', name: '3间成团' },
    { id: '2', name: '5间成团' },
    { id: '3', name: '8间成团' },
    { id: '4', name: '10间成团' },
    { id: '5', name: '散团同价' },
  ],
  parkingArr:[
    '免费大巴停车场','无大巴停车场','收费大巴停车'
  ],
  supportfacilitiesArr:[
    { id: '有会议', name: '有会议' },
    { id: '有餐饮', name: '有餐饮' }
  ],
  /*酒店、民宿的房型特征*/
  facilities: ['空气净化器','智能马桶','电动窗帘','智能电灯','电脑', '免费wifi', '客房服务', '遮光布', '熨衣设施', '24小时热水', '电视', '空调', '电热水壶', '浴缸', '吹风机', '茶几', '日报', '110V电压插座', '书桌', '暖气', '小冰箱', '迷你酒吧', '闹钟', '免费洗漱用品', '毛巾', '浴袍', '拖鞋', '小厨房', '洗衣机'],
  /*酒店设施*/
  FacilitiesBasiciconclass: [
    { id: '1', name: '室内游泳池', iconClass: 'icon-shineiyouyong' },
    { id: '2', name: '室外游泳池', iconClass: 'icon-pool' },
    { id: '3', name: '洗衣房', iconClass: 'icon-xiyifang' },
    { id: '4', name: '健身房', iconClass: 'icon-jianshenfang'},
    { id: '5', name: '中餐厅', iconClass: 'icon-zhongcanting'},
    { id: '6', name: '西餐厅', iconClass: 'icon-xicanting'},
    { id: '7', name: '茶室', iconClass: 'icon-chashi' },
    { id: '8', name: '咖啡吧', iconClass: 'icon-kafei' },
    { id: '9', name: '酒吧', iconClass: 'icon-yunxujuhui' },
    { id: '10', name: '大堂吧', iconClass: 'icon-jiudiansheshi-datangba' },
    { id: '11', name: '图书室', iconClass: 'icon-tushu' },
    { id: '12', name: '棋牌室', iconClass: 'icon-qipaishi' },
    { id: '13', name: '减压室', iconClass: 'icon-jieya' },
    { id: '14', name: '酒店商场', iconClass: 'icon-icon-' },
    { id: '15', name: '商务中心', iconClass: 'icon-shangwu' },
    { id: '16', name: '足疗中心', iconClass: 'icon-zuliao' },
    { id: '17', name: 'SAP', iconClass: 'icon-anmo' },
    { id: '18', name: '行政酒廊', iconClass: 'icon-hangzhengjiulang' },
    { id: '19', name: '温泉泡池', iconClass: 'icon-wenquan1' },
    { id: '20', name: '儿童乐园', iconClass: 'icon-leyuan' },
    { id: '21', name: '户外草坪', iconClass: 'icon-caoping' },
    { id: '22', name: '花园', iconClass: 'icon-icon_garden' },
    { id: '23', name: '公共海滩', iconClass: 'icon-haitan' },
    { id: '24', name: '充电车位', iconClass: 'icon-chongdianzhuang' },
    { id: '25', name: '公共停车位', iconClass: 'icon-tingchewei'}
  ],
   /*房间用品-设施ID为1-9*/
  RoomAmenities : (function(){
    var arr = '洗浴用品、浴袍、毛巾、拖鞋、浴缸、熨烫设施、衣架、瓶装水、茶包'
    return arr.split('、').map((item,index)=>{
      return {
        id:(index+1).toString(),
        name:item
      }
    })
  })(),
  /*房间设施-设施ID为10-22*/
  RoomFacility : (function(){
    var arr = '书桌、茶几、茶具、沙发、休闲椅、衣柜、餐桌、迷你吧、厨房、保险箱、备用床具、针线包、客房WIFI'
    return arr.split('、').map((item,index)=>{
      return {
        id:(index+1+9).toString(),
        name:item
      }
    })
  })(),
  /*房间设备-设施ID为23-36*/
  RoomEquipment : (function(){
    var arr = '电视、空调、电话、电热水壶、吹风机、小冰箱、洗衣机、电子秤、投影仪、电脑、音响、110V插座、暖气、电动窗帘'
    return arr.split('、').map((item,index)=>{
      return {
        id:(index+1+9+13).toString(),
        name:item
      }
    })
  })(),
  /*房间特色 设计师ID为37-41*/
  Roomeature: (function(){
    var arr = '智能房控、空气净化器、智能马桶、新风系统、温泉泡池'
    return arr.split('、').map((item,index)=>{
      return {
        id:(index+1+9+13+14).toString(),
        name:item
      }
    })
  })(),
  /*会议室柱子*/
  MeetingPillar: (function(){
    var arr = '无柱会场、会场中央柱子、会场侧面柱子'
    return arr.split('、').map((item,index)=>{
      return {
        id:(index+1).toString(),
        name:item
      }
    })
  })(),
  /*会议室窗户*/
  MeetingWindow: (function(){
    var arr = '有窗、无窗、落地窗、过道窗、室内窗户、小窗户'
    return arr.split('、').map((item,index)=>{
      return {
        id:(index+1).toString(),
        name:item
      }
    })
  })(),
  /*会议室设备*/
  MeetingEquipment: (function(){
    var arr = 'LED 、投影仪、音响设备、移动舞台、固定舞台、舞台灯光、白板会场续厅'
    return arr.split('、').map((item,index)=>{
      return {
        id:(index+1).toString(),
        name:item
      }
    })
  })(),
 /*酒店设施*/
  FacilitiesBasic : (function(){
    var arr = '室内游泳池、室外游泳池、洗衣房、健身房、中餐厅、西餐厅、茶室、咖啡吧、酒吧、大堂吧、图书室、棋牌室、减压室、酒店商场、商务中心、足疗中心、SAP、行政酒廊、温泉泡池、儿童乐园、户外草坪、花园、公共海滩、充电车位、公共停车位'
    return arr.split('、').map((item,index)=>{
      return {
        id:(index+1).toString(),
        name:item
      }
    })
  })(),

  /*酒店服务*/
  Facilitiesflsec : [
    { id: '1', name: '会议服务', iconClass: 'icon-huiyi1' },
    { id: '2', name: '餐饮服务', iconClass: 'icon-canyin1' },
    { id: '3', name: '婚宴服务', iconClass: 'icon-hunyin' },
    { id: '4', name: '机器人服务', iconClass: 'icon-saodijiqirenbeifen' },
    { id: '5', name: '行李寄存', iconClass: 'icon-hanglixiang1' },
    { id: '6', name: '接送机服务', iconClass: 'icon-jiejifuwu' },
    { id: '7', name: '叫醒服务', iconClass: 'icon-tixing' },
    { id: '8', name: '骑行服务', iconClass: 'icon-qihang-04' },
    { id: '9', name: '户外烧烤', iconClass: 'icon-shaokaoqiju' },
    { id: '10', name: '宠物照看', iconClass: 'icon-xiedaichongwu' },
    { id: '11', name: '儿童DIY', iconClass: 'icon-yinger' },
    { id: '12', name: '儿童托管', iconClass: 'icon-care' },
    { id: '13', name: '外币兑换', iconClass: 'icon-waibiduihuan1' },
    { id: '14', name: '旅游票务', iconClass: 'icon-f4' },
  ],
  /*酒店设施*/
  FacilitiesFacility : (function(){
    var arr = '剧院式、课桌式、宴会式、鱼骨型、U字型、回字型、岛屿式'
    return arr.split('、').map((item,index)=>{
      return {
        id:(index+1).toString(),
        name:item
      }
    })
  })(),
  /*酒店首字母*/
  SearchInitialList :[
    { id: '7', name: '7' },
    { id: 'A', name: 'A' },
    { id: 'B', name: 'B' },
    { id: 'C', name: 'C' },
    { id: 'D', name: 'D' },
    { id: 'E', name: 'E' }, 
    { id: 'F', name: 'F' },
    { id: 'G', name: 'G' },
    { id: 'H', name: 'H' },
    { id: 'I', name: 'I' },
    { id: 'J', name: 'J' },
    { id: 'K', name: 'K' },
    { id: 'L', name: 'L' },
    { id: 'M', name: 'M' },
    { id: 'N', name: 'N' },
    { id: 'O', name: 'O' },
    { id: 'P', name: 'P' },
    { id: 'Q', name: 'Q' },
    { id: 'R', name: 'R' },
    { id: 'S', name: 'S' },
    { id: 'T', name: 'T' },
    { id: 'W', name: 'W' },
    { id: 'X', name: 'X' },
    { id: 'Y', name: 'Y' },
    { id: 'Z', name: 'Z' },
  ],
  /*酒店品牌*已到99个品牌*/
  FacilitiesPlatform :[
    {type:'ABC',brand:[
      { id: '1', name: '安缦(Aman Resorts)'},
      { id: '2', name: '贝斯特韦斯特国际酒店集团(Best Western)'},
      { id: '3', name: '百乐酒店集团'},
      { id: '4', name: '半岛(Peninsula)'},
      { id: '98', name: '佰翔酒店集团'},
      { id: '5', name: '城市名人酒店集团'},
      { id: '6', name: 'Club Med(地中海俱乐部)'},
    ]},
    {type:'DFG',brand:[
      { id: '7', name: '东湖集团（Donghu Group）'},
      { id: '8', name: '大仓日航酒店集团(Okura Nikko)'},
      { id: '9', name: '帝盛酒店集团'},
      { id: '10', name: '东呈集团'},
      { id: '11', name: '德胧集团（开元&百达屋）'},
      { id: '95', name: '都喜酒店集团'},
      { id: '12', name: '富豪(Regal)'},
      { id: '13', name: '凤悦酒店集团（碧桂园）'},
      { id: '14', name: '泛太平洋(Pan Pacific)'},
      { id: '15', name: '富丽华国际酒店集团（FHI）'},
      { id: '16', name: '国丰(Guofeng)'},
      { id: '17', name: '格兰云天集团'},
      { id: '18', name: '瑰丽(Rosewood Hotel Group)'},
      { id: '19', name: '格林酒店集团'},
    ]},
    {type:'HJK',brand:[
      { id: '20', name: '衡山'},
      { id: '21', name: '华侨城'},
      { id: '22', name: '海逸(Harbor Plaza)'},
      { id: '23', name: '恒大集团'},
      { id: '24', name: '辉盛国际'},
      { id: '25', name: '汉爵集团'},
      { id: '26', name: '宏昆酒店集团'},
      { id: '27', name: '海航(HNA)'},
      { id: '28', name: '华天酒店集团'},
      { id: '29', name: '华住'},
      { id: '96', name: '黄龙酒店集团'},
      { id: '30', name: '君廷酒店及度假村集团(Barony)'},
      { id: '31', name: '锦江丽笙'},
      { id: '32', name: '嘉佩乐(Capella)'},
      { id: '33', name: '九龙仓酒店集团(Wharf hotels)'},
      { id: '34', name: '金陵'},
      { id: '35', name: '君亭酒店集团'},
      { id: '92', name: '君澜酒店集团'},
      { id: '36', name: '锦江'},
      { id: '37', name: '精选国际(Choice Hotels)'},
      { id: '38', name: '凯莱(Gloria)'},
      { id: '39', name: '柯兹纳(Kerzner)'},
      { id: '40', name: '凯宾斯基(Kempinski)'},
      { id: '41', name: '凯悦(Hyatt)'},
      { id: '93', name: '开元酒店集团'},
    ]},
    {type:'LMP',brand:[
      { id: '42', name: '雷迪森(Landison)'},
      { id: '43', name: '立鼎世'},
      { id: '44', name: '丽呈'},
      { id: '45', name: '绿地酒店旅游集团'},
      { id: '46', name: '龙之梦'},
      { id: '47', name: '丽笙(Radisson Hotel Group)'},
      { id: '48', name: '朗廷(Langham)'},
      { id: '49', name: '美高梅（MGM Resorts International）'},
      { id: '50', name: '美诺酒店集团 (MinorHotels)'},
      { id: '51', name: '玛丽蒂姆酒店集团(Maritim)'},
      { id: '52', name: '明宇集团'},
      { id: '53', name: '美豪'},
      { id: '54', name: '美利亚(Melia)'},
      { id: '55', name: '珀丽酒店集团(Rosedale)'},
      { id: '56', name: '璞廷酒店集团'},
    ]},
    {type:'QRS',brand:[
      { id: '57', name: '侨福集团'},
      { id: '58', name: '千禧(Millennium)'},
      { id: '59', name: '瑞士瑞斯丽集团'},
      { id: '60', name: '融创文旅集团'},
      { id: '61', name: '四季集团（Four seasons hotels&resorts）'},
      { id: '62', name: '书香酒店集团'},
      { id: '63', name: '世茂酒店及度假村'},
      { id: '64', name: '四川岷山集团'},
      { id: '65', name: '世纪缘酒店集团'},
      { id: '66', name: '世纪金源酒店集团'},
      { id: '67', name: '首旅酒店集团'},
    ]},
    {type:'TWX',brand:[
      { id: '97', name: '天港酒店集团'},
      { id: '68', name: '托尼洛·兰博基尼酒店'},
      { id: '69', name: '文华东方(Mandarin Oriental Hotel Group)'},
      { id: '70', name: '万豪(Marriott)'},
      { id: '71', name: '万达酒店及度假村'},
      { id: '99', name: '万斯酒店集团'},
      { id: '72', name: '温德姆(Wyndham)'},
      { id: '73', name: '星河湾集团'},
      { id: '74', name: '西美酒店管理集团'},
      { id: '75', name: '星野(Hoshino)'},
      { id: '76', name: '希尔顿(Hilton)'},
      { id: '77', name: '西溪天堂'},
      { id: '78', name: '香格里拉(Shangri-La)'},
    ]},
    {type:'YZ',brand:[
      { id: '79', name: '雅诗阁（Ascott）'},
      { id: '80', name: '粤海国际(GDHM)'},
      { id: '81', name: '御庭集团'},
      { id: '82', name: '远洲集团 '},
      { id: '83', name: '延年酒店集团'},
      { id: '84', name: '雅辰酒店集团'},
      { id: '94', name: '艺龙酒店集团'},
      { id: '85', name: '悦榕集团（Banyan Group ）'},
      { id: '86', name: '亚朵集团'},
      { id: '87', name: '雅高(Accor)'},
      { id: '88', name: '卓美亚(Jumeirah)'},
      { id: '89', name: '中维酒店集团'},
      { id: '90', name: '中旅酒店集团'},
      { id: '91', name: '洲际(IHG)'},
    ]}
  ],
  /*风格标签*/
  StyleLabel_old: [
    { id: 1, name: '经济型' },
    { id: 2, name: '舒适型' },
    { id: 3, name: '豪华型' },
    { id: 4, name: '奢华型' }
  ],
  /*装修风格*/
  DecorationLabel_old: [
    { id: 1, name: '现代风格' },
    { id: 2, name: '复古风格' },
    { id: 3, name: '欧式风格' },
    { id: 4, name: '工业风格' },
    { id: 5, name: '田园风格' }
  ],
  /*接待资质*/
  receptionAccess:[
    { id: '1', name: '涉外' },
    { id: '0', name: '不涉外' },
  ],
  /*类型标签*/
  TypeLabel: (function(){
    var arr = '品牌连锁、商务会议、亲子度假、温泉泡汤、园林花园、设计师酒店、网红打卡、电竞酒店'
    return arr.split('、').map((item,index)=>{
      return {
        id:(index+1).toString(),
        name:item
      }
    })
  })(),
  /*酒店类型*/
  StyleLabel: (function(){
    var arr = '酒店、民宿、酒店公寓、客栈、农家乐、青年旅舍、度假别墅'
    return arr.split('、').map((item,index)=>{
      return {
        id:(index+1).toString(),
        name:item
      }
    })
  })(),
  /*装修风格*/
  DecorationLabel  : (function(){
    var arr = '现代豪华、现代轻奢、现代简约、中式复古、新中式、田园闲适、工业风格、欧式高雅、简欧风格、北欧风格、日式风格、地中海风格、东南亚风格、法式风格、美式风格、伊斯兰风格'
    return arr.split('、').map((item,index)=>{
      return {
        id:(index+1).toString(),
        name:item
      }
    })
  })(),
  /*主题特色*/
  SubjectType:[
    { id: '1', name: '品牌连锁'},
    { id: '2', name: '商务会议'},
    { id: '3', name: '亲子度假'},
    { id: '4', name: '温泉泡汤'},
    { id: '5', name: '园林花园'},
    { id: '6', name: '设计师酒店'},
    { id: '7', name: '网红打卡'},
    { id: '8', name: '电竞酒店'},
    { id: '9', name: '营地露营'},
    { id: '10', name: '轰趴'},
    { id: '11', name: '疗休养基地'},
  ],
  //双人间数量
  twinRoomQuantity: [ 
      {id: 1, name: '50间以上'}, 
      {id: 2, name: '100间以上'},
      {id: 3, name: '150间以上'}, 
      {id: 4, name: '200间以上'}, 
      {id: 5, name: '250间以上'}, 
      {id: 6, name: '300间以上'}
  ],
}
